import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-call-timer',
  templateUrl: './call-timer.component.html',
  styleUrls: ['./call-timer.component.scss']
})
export class CallTimerComponent implements OnDestroy, OnInit {
  callDuration = 0;
  timer: any;
  isCallActive = false;

  ngOnInit(): void {
    this.start();
  }

  start() {
    this.isCallActive = true;
    this.callDuration = 0;

    this.timer = setInterval(() => {
      this.callDuration++;
    }, 1000);
  }

  end() {
    this.isCallActive = false;
    clearInterval(this.timer);
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes < 10 ? '0' : ''}${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }
}
